import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'core-pipe-names',
  templateUrl: './pipe-names.component.html',
})
export class PipeNamesComponent {
  @ViewChild('strings', { static: true, read: ElementRef }) s: ElementRef;
}
